import type { AppThunk } from '@core/core/store'
import type { Nullable, ProjectId } from 'common/types'

import { updateProjectApi } from '../../api'
import type { CompanyId, FieldId, ProjectType } from '../../types'
import { getAllProjects } from '../projects'
import { projectSlice } from './projectSlice'

export const {
  addFieldToProject,
  setProject,
  addSurveyToProject,
  addMapToProject,
  addCubeToProject,
} = projectSlice.actions

export const updateProject =
  (
    projectId: ProjectId,
    name: string,
    type: ProjectType,
    projectYear: number,
    companyId?: Nullable<CompanyId>,
    fieldId?: Nullable<FieldId>,
  ): AppThunk =>
  dispatch => {
    updateProjectApi(projectId, name, type, projectYear, companyId, fieldId)
      .then(successful => {
        if (successful) {
          dispatch(getAllProjects({ skipSizeRequest: true }))
        }
      })
      .catch(console.error)
  }

export const setExistingProject =
  (projectId: ProjectId): AppThunk =>
  dispatch => {
    dispatch(setProject(projectId))
  }
